// extracted by mini-css-extract-plugin
module.exports = {"content":"saleHeaderElement_content__mi06X","info":"saleHeaderElement_info__2G6dw","key":"saleHeaderElement_key__1SMZg","value":"saleHeaderElement_value__3-OKX"};